import { AttivitaService } from './../services/attivita.service';
import { Component, OnInit } from '@angular/core';
import * as Enum from '../utils/enums';
import { Loading } from '../utils/loading';
import { AlertUtil } from '../utils/alert-util';
import { CommessaService } from '../services/commessa.service';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/api';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { ICommessa } from '../interfaces/ICommessa';
import { IEsecutore } from '../interfaces/IEsecutore';
import { EsecutoreService } from '../services/esecutore.service';
import { IAttivita } from '../interfaces/IAttivita';
import * as Constants from '../utils/constants';
import { PaymentModalComponent } from '../payment-modal/payment-modal.component';
import { IPagamento } from '../interfaces/IPagamento';
import { NewSalModalComponent } from '../new-sal-modal/new-sal-modal.component';
import { PaymentForCommessaModalComponent } from '../payment-for-commessa-modal/payment-for-commessa-modal.component';
import { SalForCommessaModalComponent } from '../sal-for-commessa-modal/sal-for-commessa-modal.component';
import { CommessaSalPaymentModalComponent } from '../commessa-sal-payment-modal/commessa-sal-payment-modal.component';
import { EsecutorePagamentiModalComponent } from '../esecutore-pagamenti-modal/esecutore-pagamenti-modal.component';
import { AttivitaSalPaymentModalComponent } from '../attivita-sal-payment-modal/attivita-sal-payment-modal.component';

@Component({
  selector: 'app-sal',
  templateUrl: './sal.component.html',
  styleUrls: ['./sal.component.css']
})
export class SalComponent implements OnInit {

  commesse: any[]  // table data source commesse
  esecutori: any[]  // table data source esecutori
  listaAttivita: IAttivita[] = [] //list attivita
  listAttivitaCommesse: IAttivita[] = [] //list attivita type Commessa
  listAttivitaCantiere: IAttivita[] = []//list attivita type Cantiere
  objSALByAttivita: IAttivita//obj sal to single attivita

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  L = Loading                     //export loading for html

  commessaSelected: boolean = false    //determines whether one commessa row has been clicked
  esecutoreSelected: boolean = false    //determines whether one esecutore row has been clicked
  esecutore: IEsecutore //Esecutore selected
  listPagamentiEsecutore: IPagamento[] //list pagamenti to esecutore selected

  attivitaSelected: boolean = false    //determines whether one attivita row has been clicked
  attivita: IAttivita //Attivita selected

  isAggiudicatario: boolean //determines whether the user logged is aggiudicatario 
  isPrefetto: boolean //determines whether the user logged is prefetto 
  isExecutor: boolean //determines whether the user logged is executor 
  disablePaymentTooltip: boolean = false

  commessaSel:ICommessa //obj commessa selected

  constructor(private alertUtil: AlertUtil,
    private commessaService: CommessaService,
    private translate: TranslateService,
    public dialogService: DialogService,
    private esecutoreService: EsecutoreService,
    private attivitaService: AttivitaService) { }

  ngOnInit() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    this.checkUserRole(userRole)
    setTimeout(() => {
      this.getAllCommesse()
    }, 0);
  }

  /**
  * check role of user logged
  */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true
      this.disablePaymentTooltip = true
    } else if(userRole == Enum.USER_TYPE_ENUM.PREFETTURA
      || userRole == Enum.USER_TYPE_ENUM.DL){
      this.isPrefetto = true
    } else if(userRole == Enum.USER_TYPE_ENUM.ESECUTORE){
      this.isExecutor = true
    }
  }

  /**
   * retrieve all commesse
   */
  getAllCommesse() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.commessaService.getAllCommesse(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.commesse = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * callback fired when one commessa row is selected
   * @param commessa
   */
  onCommessaRowSelected(commessa: ICommessa) {
    Loading.isLoading = true
    this.commessaSelected = true
    this.getAllEsecutori(commessa)
  }

  /**
   * callback fired when one commessa row is unselected
   */
  onCommessaRowUnselected() {
    this.commessaSelected = false
    this.esecutoreSelected = false
    this.attivitaSelected = false
  }

  /**
   * Get all esecutori of selected commessa
   * @param commessa 
   */
  getAllEsecutori(commessa: ICommessa) {
    let requestBuilder = new RequestBuilder({ Id: commessa.Id })
    this.commessaService.getEsecutoriCommessa(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response.data) {
        this.esecutori = response.data
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    })
  }

  /**
   * Get all attivita of selected esecutore
   * @param esecutore 
   */
  onEsecutoreRowSelected(currentEsecutore: IEsecutore) {
    Loading.isLoading = true
    this.listAttivitaCantiere = []
    this.listAttivitaCommesse = []
    this.esecutoreSelected = true
    this.esecutore = currentEsecutore
    this.getAttivita(currentEsecutore)
  }

  /**
   * return all attivita for esecutore selected
   * @param esecutore esecutore selected
   */
  getAttivita(esecutore: IEsecutore) {
    let requestBuilder = new RequestBuilder({ Id: esecutore.Id })

    this.esecutoreService.getAttivitaByEsecutore(requestBuilder).subscribe(response => {
      Loading.isLoading = false
      if (response.data) {
        this.listaAttivita = response.data

        this.listaAttivita.forEach(attivita => {
          /** variabile per html */
          attivita.Disabled = true;
          attivita.Importo = null;
          if (attivita.Cantiere) {
            this.listAttivitaCantiere.push(attivita)
          } else {
            this.listAttivitaCommesse.push(attivita)
          }
        })

      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    })
  }

  /**
    * callback fired when one esecutore row is unselected
    */
  onEsecutoreRowUnselected() {
    this.esecutoreSelected = false
  }

  /**
  * open modal
  */
  openPaymentModal() {
    //get header translation
    this.translate.get("LBL_NEW_PAYMENT").subscribe(res => {
      //open commessa modal
      let paymentModal = this.dialogService.open(PaymentModalComponent, {
        data: {
          listaAttivita: this.listaAttivita
        },
        header: res,
        width: '80%'
      })
    })
  }

  /**
   * new SAL item clicked
   */
  newSALclicked(attivitaSelected: IAttivita) {
    this.attivita = attivitaSelected
    this.attivitaFetchSingleService(true)
  }

  /**
   * modal for new SAL for attivita
   */
  newSALModal() {
    //get header translation
    this.translate.get("LBL_NEW_SAL").subscribe(res => {
      //open new sal modal
      this.dialogService.open(NewSalModalComponent, {
        data: {
          objSALByAttivita: this.objSALByAttivita
        },
        header: res,
        width: '50%'
      })
    })
  }

  /**
   * row attivita selected
   * @param attivitaSelected attivita
   */
  onAttivitaRowSelected(attivitaSelected: IAttivita) {
    Loading.isLoading = true
    this.attivitaSelected = true
    this.attivita = attivitaSelected
    this.attivitaFetchSingleService(false)
  }

  /**
   * row attivita unselected
   */
  onAttivitaRowUnselected() {
    this.attivitaSelected = false
  }

  /**
   * call fetch attivita service
   */
  attivitaFetchSingleService(isNewSal: boolean) {
    let reqBuilderPath = ['rel_PagamentoAttivita.Pagamento', 'SAL']
    let requestBuilder = new RequestBuilder({ Id: this.attivita.Id }, reqBuilderPath)
    this.attivitaService.fetchSingle(requestBuilder).subscribe(response => {
      Loading.isLoading = false
      if (response.data) {
        this.objSALByAttivita = response.data
        if (isNewSal) {
          this.newSALModal()
        } else {
          this.openModalSALPayments()
        }
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    })
  }

  /**
   * open modal SAL and payment to single Attivita
   */
  openModalSALPayments() {
    //get header translation
    this.translate.get("MENU_SAL").subscribe(res => {
      //open sal modal
      this.dialogService.open(AttivitaSalPaymentModalComponent, {
        data: {
          objSALByAttivita: this.objSALByAttivita
        },
        header: res,
        width: '80%'
      })
    })
  }

  /**
   * call fetch pagamenti by esecutore 
   */
  fetchPagamentiByEsecutore(currentEsecutore: IEsecutore) {
    let requestBuilder = new RequestBuilder({ Id: currentEsecutore.Id })
    this.esecutoreService.getPagamentiByEsecutore(requestBuilder).subscribe(response => {
      Loading.isLoading = false
      if (response.data) {
        this.listPagamentiEsecutore = response.data
        this.openPagamentiEsecutoreModal()
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + response.error.Stack)
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    })
  }

  /**
   * open pagamenti modal from table esecutore 
   * @param event 
   */
  openPagamentiEsecutoreModal() {
    //get header translation
    this.translate.get("LBL_PAGAMENTI_LIST").subscribe(res => {
      //open payment modal
      this.dialogService.open(EsecutorePagamentiModalComponent, {
        data: {
          listPagamenti: this.listPagamentiEsecutore
        },
        header: res,
        width: '55%'
      })
    })
  }

  /**
   * open modal 
   * new Payment for commessa
   */
  newPaymentForCommessa() {
    //get header translation
    this.translate.get("LBL_NEW_PAYMENT").subscribe(res => {
      //open payment modal
      this.dialogService.open(PaymentForCommessaModalComponent, {
        data: {
          listCommesse: this.commesse
        },
        header: res,
        width: '50%'
      })
    })
  }

  /**
   * open modal 
   * new SAL for commessa
   */
  newSALForCommessa() {
    //get header translation
    this.translate.get("LBL_NEW_SAL").subscribe(res => {
      //open payment modal
      this.dialogService.open(SalForCommessaModalComponent, {
        data: {
          listCommesse: this.commesse
        },
        header: res,
        width: '50%'
      })
    })
  }


  /**
   * show pagamenti and SAL for commessa
   * @param commessa 
   */
  showPagAndSALByCommessa(commessaSelected: ICommessa) {
    Loading.isLoading = true
    this.commessaSel = commessaSelected
    this.callCommessaFetchSingle()
  }


  /**
   * call commessa fetch single
   */
  callCommessaFetchSingle() {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({Id: this.commessaSel.Id},["SAL","Pagamenti"])
    this.commessaService.getCommessaData(reqBuilder).subscribe(
      response => {
        Loading.isLoading = false
        if (response.data) {
          this.commessaSel = response.data
          this.openModalSALPaymentsForCommessa()
        } else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        } else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        Loading.isLoading = false
        let errorKey ="LBL_HTTP_ERROR_0"
        if(error.status){
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * open modal SAL and payment to single Commessa
   */
  openModalSALPaymentsForCommessa() {
    //get header translation
    this.translate.get("MENU_SAL").subscribe(res => {
      //open sal modal
      this.dialogService.open(CommessaSalPaymentModalComponent, {
        data: {
          commessa: this.commessaSel
        },
        header: res,
        width: '80%'
      })
    })
  }
}